import { render, staticRenderFns } from "./SonBanner.vue?vue&type=template&id=9fd14d3a&scoped=true"
import script from "./SonBanner.vue?vue&type=script&lang=js"
export * from "./SonBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fd14d3a",
  null
  
)

export default component.exports